import 'jquery-validation';
import {hideButtonLoader, showButtonLoader, isStrongPassword, getStrongPasswordErrorMessage} from "../util/helpers";

export default {
  init: function () {

    var resetForm = $('#resetPasswordForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);

      setTimeout(() => {
        var valid = resetForm.valid();
        if (valid) {
          setTimeout(function () {
            resetForm.submit();
          }, 1000);
        } else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

    $.validator.addMethod("passwordCustomRules", function(value) {
      // SPOT allow up to 30 chars and will not notify us about it, it will just say that pass doesn't meet the requirements
      return isStrongPassword(value) && value.length < 30;
    }, () => getStrongPasswordErrorMessage());

    resetForm.validate({
      errorElement: "span",
      rules: {
        password: {
          passwordCustomRules: true,
          required: true,
        },
        password2: {
          equalTo: "#inputPassword",
          required: function () {
            return $("#inputPassword").val().length > 0;
          },
        },
      },
    });

    /**
     * Toggle password type to view password
     */
    const inputPassword = $('.mb-account-reset__password input');
    const inputRePassword = $('#inputRePassword');
    $('.mb-account-reset__eye').click(function () {
      function changeInputTypeToText(input) {
        if (input.attr('type') === 'text') {
          input.attr('type', 'password');
        } else {
          input.attr('type', 'text');
        }
      }

      changeInputTypeToText(inputPassword);
      changeInputTypeToText(inputRePassword);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/resetpassword.js